import FooterLink from '@root/joinroot.com/src/components/footer/footer-link';
import FooterLinksColumn from '@root/joinroot.com/src/components/footer/footer-links-column';
import FooterLinksContainer from '@root/joinroot.com/src/components/footer/footer-links-container';
import React from '@root/vendor/react';

export default function FooterLinks() {
  return (
    <FooterLinksContainer>
      <FooterLinksColumn>
        <FooterLink
          isInternal
          linkText={'Car insurance FAQ'}
          url={'/help/'}
        />
        <FooterLink
          isInternal
          linkText={'Car insurance coverage'}
          url={'/coverage'}
        />
        <FooterLink
          isInternal
          linkText={'Renters insurance'}
          url={'/renters-insurance/'}
        />
        <FooterLink
          isInternal
          linkText={'Homeowners insurance'}
          url={'/homeowners-insurance/'}
        />
        <FooterLink
          isInternal
          linkText={'Claims'}
          url={'/claims'}
        />
        <FooterLink
          isInternal
          linkText={'Test drive'}
          url={'/test-drive'}
        />
        <FooterLink
          isInternal
          linkText={'Referrals'}
          url={'/referrals'}
        />
        <FooterLink
          isInternal
          linkText={'Affiliates'}
          url={'/affiliates'}
        />
        <FooterLink
          isInternal
          linkText={'Contact'}
          url={'/contact'}
        />
      </FooterLinksColumn>
      <FooterLinksColumn>
        <FooterLink
          isInternal
          linkText={'Mobile app'}
          url={'/mobile-app'}
        />
        <FooterLink
          isInternal
          linkText={'Auto insurance by state'}
          url={'/availability'}
        />
        <FooterLink
          linkText={'Customer reviews'}
          url={'/customer-reviews'}
        />
        <FooterLink
          linkText={'Car insurance comparison'}
          url={'/car-insurance-comparison'}
        />
        <FooterLink
          linkText={'How to manage your policy'}
          url={'/how-to-manage-your-policy'}
        />
        <FooterLink
          isInternal
          linkText={'Car insurance quote'}
          url={'/quote'}
        />
        <FooterLink
          linkText={'Car insurance discounts'}
          url={'/discounts'}
        />
        <FooterLink
          isInternal
          linkText={'Company'}
          url={'/company'}
        />
        <FooterLink
          linkText={'Careers'}
          url={'/careers/'}
        />
      </FooterLinksColumn>
      <FooterLinksColumn>
        <FooterLink
          isInternal
          linkText={'Press'}
          url={'/press'}
        />
        <FooterLink
          linkText={'Blog'}
          url={'/blog/'}
        />
        <FooterLink
          linkText={'Terms and conditions'}
          url={'/terms-and-conditions'}
        />
        <FooterLink
          isInternal
          linkText={'Privacy policy'}
          url={'/privacy-policy'}
        />
        <FooterLink
          isInternal
          linkText={'App license agreement'}
          url={'/app-eula'}
        />
        <FooterLink
          linkText={'UGC privacy notice'}
          url={'/ugc-privacy-notice'}
        />
        <FooterLink
          isInternal
          linkText={'Weather related events'}
          url={'/weather/'}
        />
        <FooterLink
          isInternal
          linkText={'Non-weather emergencies'}
          url={'/non-weather/'}
        />
        <FooterLink
          isInternal
          linkText={'Sitemap'}
          url={'/sitemap/'}
        />
      </FooterLinksColumn>
    </FooterLinksContainer>
  );
}
